import { render, staticRenderFns } from "./InputError.vue?vue&type=template&id=b8f6955c&scoped=true&lang=pug&"
import script from "./InputError.vue?vue&type=script&lang=ts&"
export * from "./InputError.vue?vue&type=script&lang=ts&"
import style0 from "./InputError.vue?vue&type=style&index=0&id=b8f6955c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f6955c",
  null
  
)

export default component.exports